function print($container) {
    if (!$container) {
        return;
    }

    import('../../jsscripts/jquery/printThis.js').then(() => {
        $($container).printThis();
    });
}

function copyToClipboard($shareButton) {
    if (!$shareButton) {
        return;
    }

    import('clipboard').then(({ default: Clipboard }) => {
        new Clipboard($shareButton);
        $shareButton.click();
    });
}

export default function comparisonTools($container) {
    if (!$container) {
        throw new Error(`comparisonTools functions could not located the DOM element`);
    }

    const $toolbar = $container.querySelector('#comparison-tools');

    if (!$toolbar) {
        throw new Error(`comparisonTools functions could not located the DOM element`);
    }

    let $inputURL;
    let originalURL;

    const setFiltersInURL = filters => {
        if (!$inputURL) {
            $inputURL = $toolbar.querySelector('#share-url');
        }

        if (!originalURL) {
            originalURL = $inputURL.value;
        }

        if (!Array.isArray(filters) || !filters.length) {
            $inputURL.value = originalURL;
            return;
        }

        $inputURL.value = `${originalURL.split('?')[0]}?filters=${encodeURIComponent(filters.toString())}`;
    };

    $toolbar.querySelector('.printFrame')?.addEventListener('click', event => {
        event.preventDefault();
        print($container.parentElement.querySelector('#printThis'));
    });

    $toolbar.querySelector('#share-copy-button')?.addEventListener('click', function loadClipBoard(event) {
        event.preventDefault();
        event.target.removeEventListener('click', loadClipBoard);
        copyToClipboard(event.target);
    });

    return {
        setFiltersInURL
    };
}